<template>
  <div>
    <v-btn class="button-item" text @click="copyToClipboard()">
      <v-icon>content_copy</v-icon>
    </v-btn>
    <v-tooltip v-model="show" top>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on"></div>
      </template>
      <span>{{ $t('rooms.urlSaved') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { copyToClipboard } from '@/script/utils.js'

export default {
  name: 'CopyClipboardButton',

  props: {
    copyFrom: {
      type: String,
      default: ''
    },
    copy: {
      type: String,
      default: null
    }
  },

  data: () => {
    return {
      show: false
    }
  },

  methods: {
    copyToClipboard() {
      if (!this.copy) return

      copyToClipboard(this.copy)
      this.$mam.liveCopy(this.copyFrom)

      this.show = !this.show

      setTimeout(() => {
        this.show = false
      }, 1000)
    }
  }
}
</script>

<style lang="sass" scoped>
.button-item
  width: 50px
  height: 100% !important
  display: flex
  justify-content: center
  align-items: center
  &:hover
    color: var(--v-primary-darken1)
</style>
